import { EpimsBaseEntityDto } from './epim-base.dto';

export class AdrPersonnelDto extends EpimsBaseEntityDto {

    AdrPersonnelId: string;
    AdrId: string;
    SuitNo: string;
    PersonnelName: string;   
    CommunityId: string; 
    Address: string; 
    Phone: string; 
    RolePlayed: string; 
    InputStaff: string; 
    InputDate: Date; 
    SubscriptionUserId: string; 
    SubscriberId: string; 


}